{
    "webshop_offer_voucher_correctCode": "输入的验证码正确",
    "webShop_howToFindId_desc": "您可以在玩家个人资料中找到并复制个人 ID。",
    "webShop_howToFindId_link": "哪里可以找到我的个人 ID？",
    "webshop_offer_voucher_codeIsIncorrect": "代码不正确",
    "webshop_offer_voucher_enterYourCode": "输入您的个人 ID",
    "webShop_unexpectedError_desc": "发生意外错误，请稍后重试。",
    "webShop_accountBanned_desc": "帐户被封！",
    "webshop_confirm": "确定",
    "webshop_termsConditions_1": "条款和条件",
    "webshop_purchase_privacyPolicy": "隐私政策",
    "webshop_legal_1": "法律",
    "webshop_support_1": "支持",
    "mbs_access_welcome_desc": "欢迎，{0}",
    "btn_login": "登录",
    "mbs_access_error_sessionExpired_desc": "您本次游戏已过期。请手动输入您的帐户 ID。"
}
